var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.959 9.81 0 13.953l4.751-.835L16 3.308 12.207 0 .959 9.81Zm.746 2.658.482-2.084 1.906 1.663-2.388.42Zm12.408-9.16-9.077 7.917L3.129 9.56l9.078-7.917 1.906 1.664Z"
  })));
};
export default SvgEdit;